import { useQueryClient, useMutation } from "@tanstack/react-query";
import { type ToastType } from "../../interfaces/toast.interface";
import { useHandleResponse } from "../useHandleResponse";
import { register } from "../../api/auth.api";

export const useRegister = () => {
  const handleResponse = useHandleResponse();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: register,

    onSuccess: (data) => {
      queryClient.setQueryData(["user"], data.user);
      const toastType: ToastType = "success";
      handleResponse(
        toastType,
        "Account Created Successfully. Please check your inbox for a verification email!",
        null,
        10000,
      );
    },

    onError: (error) => {
      const toastType: ToastType = "error";
      handleResponse(toastType, "Failed to register", error, 5000);
    },
  });
};
